import { ChangeDetectorRef, Component, ElementRef, Optional, OnInit, Inject, ViewChild } from '@angular/core';
import { environment as env } from '@env/environment';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { ICompany } from '@app/core/interfaces/ICompany';
import { IContact } from '@app/core/interfaces/IContact';
import { IUser } from '@app/core/interfaces/user/IUser';
import { IInvoice } from '@app/core/interfaces/IInvoice';
import { CompanyService } from '@app/core/services/CompanyService';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { CurrencyService } from '@app/core/services/CurrencyService';
import { ReportService } from '@app/core/services/ReportService';
import { IEmployerTax } from '@app/core/interfaces/IEmployerTax';
import { UserService } from '@app/core/services/UserService';
import { EmployerTaxService } from '@app/core/services/EmployerTaxService';
import { debug } from '@app/core/meta-reducers/debug.reducer';
import { IAllowance } from '@app/core/interfaces/invoice/IAllowance';
import { ITransactionLog } from '@app/core/interfaces/invoice/ITransactionLog';
import { TransactionLogService } from '@app/core/services/TransactionLogService';
import { IDeduction } from '@app/core/interfaces/invoice/IDeduction';
import { InvoiceAdminDialogComponent } from '../../mypages/invoices/invoice-admin.Dialog.Component';
import { ITaxAdjustmentThresholdStatus } from '@app/core/interfaces/user/ITaxAdjustmentThresholdStatus';
import { firstValueFrom } from 'rxjs';
import { calculatePension, isPensionWithinLimit } from '@app/core/services/pension-calculation';

export interface TableRow {
  loneart: string;
  kmAntal: string | number;
  sekDag: string | number;
  arbGivAvg: string | number;
  bruttoLon: string | number;
  inkSkatt: string | number;
  nettoLonBelopp: string | number;
}

@Component({
  standalone: false,
  selector: 'invoice-summary',
  templateUrl: './invoice-summary.component.html',
  styleUrls: ['./invoice-summary.component.scss']
})

export class InvoiceSummaryComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  versions = env.versions;
  id: number;
  companies = [];
  currencies = [];
  employerTaxes = [];
  totalInvoiceAmount: number = 0;
  ref: IContact = { Id: 0, Address: "", City: "", Email: "", Name: "", NameLocked: false, Phone: "", Zip: "", IDNumber: "" };
  invoice: IInvoice;
  invoiceQuickGroupTemplate = { Vat: "25", Type: { Value: "4", Name: "Övrigt" }, rowTypeSelected: "4" };
  invoiceQuickGroup = JSON.parse(JSON.stringify(this.invoiceQuickGroupTemplate));
  vatList = [];
  invoiceShareTypes = [];
  addToInvoiceList = [{ Name: 'Ja', Value: true }, { Name: 'Nej', Value: false }];
  paymentTerms = [10, 15, 20, 25, 30];
  isLoading = true;
  calculationError = '';
  private payoutBeforeSave: { invoiceId: number, logIds: number[], amounts: Partial<ITransactionLog> } | null = null;
  isViewReady = false;
  @ViewChild('payoutSection') private payoutSection?: ElementRef<HTMLElement>;
  private scrollToPayoutAfterSave: number | null = null;
  summaryInfoExpanded = false;
  payoutChecksComplete = false;
  feePaidByReciever: boolean = false;
  feePaidBySender: boolean = false;
  milageTotalAmount = 0;
  allowancesTotalAmount = 0;
  payoutEmployerTax = null;
  PayoutMunicipalityTax = 0;
  TotalPayout: number;
  DeductionsTotalAmount: number;
  ExpensesTotalAmount: number;
  deductionsTotalAmountOriginal: number = 0;
  expensesTotalAmountOriginalRounded: number = 0;
  expensesTotalAmountRounded: number = 0;
  netExpensesAdjustmentAmount: number = 0;
  TotalInvoiceAmount: number;
  EmployerTax = 0
  PartialAmountExclNetExpenses: number;
  PensionSavingsInclTax: number;
  userEmployerTax: any;
  paidGrossSalaryInPayoutMonth: number = 0;
  paidGrossSalaryInPayoutMonthKey: string = "";
  employerTaxBreakdown = {
    isHistorical: false,
    hasTempYouthCalculation: false,
    hasSplit: false,
    monthlyLimit: 25000,
    paidGrossSalaryInPayoutMonth: 0,
    remainingTempYouthGrossSalary: 0,
    tempYouthGrossSalary: 0,
    tempYouthEmployerTaxAmount: 0,
    tempYouthTaxRate: 0,
    normalGrossSalary: 0,
    normalEmployerTaxAmount: 0,
    normalTaxRate: 0
  };
  InvoiceFeeReceiver = 0;
  InvoiceFeeMember = 0;
  PersonalNumber: any;
  InvoiceFeePaidByCustomer: any;
  municipalityTaxRounded: any;
  PartialTotalAmount: number;
  ServiceFee: 0;
  pensionSavingsTaxFactor = 0.2426;
  pensionSavingsTaxAmount = 0;
  attachmentPaymentToKronofogdenAmount = 0;
  serviceFeeFactor: number = 0;
  zeroTaxChecked: boolean = false;
  ServiceFeeInfo: string = "";
  numberOfInvoices: number = 0;
  hasPreviousPensionSaving: boolean = false;
  pensionSavingsMessage: string = "";
  lastPayoutLog: ITransactionLog;
  lastPayoutMessage: string = "";
  taxChangedThisMonth: boolean = false;
  lastPaymentIsNextMonth: boolean = false;
  deductionMessage: string;
  deductionsValid: boolean;
  saveValid: boolean = false;
  private originalSubtotalInputs: number[] | null = null;
  private zeroTaxBelowLimit: boolean | null = null;
  saveMessage: string;
  healthCareDeductionsMessage: string;
  approvedDeductions: Array<IDeduction>;
  healthCareDeductionsTotalAmount: number = 0;
  healthCareDeductionsTotalAmountExcludingCurrent: number = 0;
  healthCareTotalAmountThisInvoice: number = 0;
  healthCareTotalAmountThisInvoiceOriginal: number = 0;
  healthCareAmountExceedesLimit: boolean = false;
  hasUnhandledTaxAdjustments: boolean = false;
  taxAdjustmentThresholdStatus: ITaxAdjustmentThresholdStatus | undefined;
  taxAdjustmentThresholdExceeded: boolean = false;
  taxAdjustmentThresholdMessage: string = '';
  taxAdjustmentSplitDetails: string = '';
  municipalityTaxFactor: number = 0;
  ordinaryMunicipalityTaxFactor: any;
  userHasWageGarnishment: boolean = false;
  userWageGarnishmentsCurrentMonth: number = 0;
  deductionsEligibleForGarnishment: number = 0;
  allowancesEligibleForGarnishment: number = 0;
  netPaidThisMonth: number = 0;
  messageToKFM: string = '';
  textSender: string = '';
  garnishmentButtonUpdated: boolean = false;
  tempYouthCalculationUpdated: boolean = false;
  transactionLogs: ITransactionLog[] = [];
  payoutTransactionLog: ITransactionLog | undefined;
  displayedPayoutName: string = '';
  tableRows: TableRow[] = [];
  transLogsRetrieved: boolean = false;
  private readonly payoutTransactionLogTypeId: number = 4;
  totalAssessableAmount: number = 0;
  activeWageGarnishment: any = null;
  openedByModal: boolean = false;
  payoutDayInfo: string = '';
  payoutDayInfoColor: string = 'inherit';
  payoutDaySelectedInfo: string = '';
  payoutDayWasAdjusted: boolean = false;
  private swedishBankHolidayCache: Map<number, Set<string>> = new Map();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, 
    private companyService: CompanyService,
    private invoiceService: InvoiceService,
    private currencyService: CurrencyService,
    private userService: UserService,
    private employerTaxService: EmployerTaxService,
    private reportService: ReportService,
    private transactionLogService: TransactionLogService,
    private changeDetectorRef: ChangeDetectorRef,
    @Optional() public dialogRef: MatDialogRef<InvoiceSummaryComponent>
  ) {

  }

  ngOnInit(): void {
    
    const dialogId = this.data ? this.data.id : null;
    this.openedByModal = dialogId ? true : false;
    const routeId = this.route.snapshot.paramMap.get('id');
    this.id = dialogId || +routeId || 0;

    if (this.id > 0) {
      this.loadInvoice(this.id);
    }

    this.loadCurrencies();
    this.loadEmployerTaxes();
    this.vatList.push({ Value: "25" }, { Value: "12" }, { Value: "6" }, { Value: "0" });
  }

  onClose(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  async setUserWageGarnishmentsCurrentMonth(userId: string): Promise<void> {
    const response = await firstValueFrom(this.userService.getUserWageGarnishmentsForCurrentMonth(userId));
    this.userWageGarnishmentsCurrentMonth = response.wageGarnishmentAmount;
    this.netPaidThisMonth = response.netPaidThisMonth;

    if (this.invoice && this.invoice.Id && !this.transLogsRetrieved) {
      await this.getTransactionLogByInvoiceId(this.invoice.Id);
    }

    const executedPayoutLog = this.payoutTransactionLog;

    if (executedPayoutLog) {
      const currentInvoiceGarnishment = (this.transactionLogs || [])
        .filter(log => !!log && !!log.Type && log.Type.TechnicalName == 'AttachmentOfSalary')
        .reduce((sum, log) => sum + (log.AttachmentOfSalaryAmount || 0), 0);

      this.userWageGarnishmentsCurrentMonth = Math.max(
        0,
        this.userWageGarnishmentsCurrentMonth - currentInvoiceGarnishment
      );
      this.netPaidThisMonth = Math.max(
        0,
        this.netPaidThisMonth - this.getCurrentInvoiceGarnishableNetPaidAmount(executedPayoutLog)
      );
    }
  }

  private getCurrentInvoiceGarnishableNetPaidAmount(executedPayoutLog: ITransactionLog): number {
    if (!this.invoice) {
      return 0;
    }

    const garnishableAllowances = (this.invoice.Allowances || [])
      .filter(allowance => !!allowance && allowance.ApprovedByAdmin === true && allowance.IsGarnishable === true)
      .reduce((sum, allowance) => sum + (allowance.Sum || 0), 0);

    const garnishableDeductions = (this.invoice.Deductions || [])
      .filter(deduction => !!deduction && deduction.ApprovedByAdmin === true && deduction.IsGarnishable === true)
      .reduce((sum, deduction) => sum + this.getDeductionAdjustedAmount(deduction), 0);

    return Math.max(
      0,
      (executedPayoutLog.NetSalary || 0) + garnishableAllowances + garnishableDeductions -
      (executedPayoutLog.AttachmentOfSalaryAmount || 0)
    );
  }

  private getActiveAttachmentOfSalary(referenceDate?: Date | string): any {
    const attachments = this.invoice?.UserSettings?.AttachmentOfSalaries || [];
    const compareDate = referenceDate ? new Date(referenceDate) : new Date();

    if (isNaN(compareDate.getTime())) {
      return null;
    }

    compareDate.setHours(0, 0, 0, 0);

    return attachments
      .filter(attachment => {
        if (!attachment || !attachment.DateStart || !attachment.DateEnd) {
          return false;
        }

        const startDate = new Date(attachment.DateStart);
        const endDate = new Date(attachment.DateEnd);

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          return false;
        }

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        return startDate <= compareDate && endDate >= compareDate;
      })
      .sort((a, b) => (b?.Id || 0) - (a?.Id || 0))[0] || null;
  }

  async getTransactionLogByInvoiceId(invoiceId: number): Promise<void> {
    try {
      const data = await firstValueFrom(
        this.transactionLogService
          .getTransactionLogByInvoiceId(invoiceId)
      );

      this.transactionLogs = data ? data : [];
      this.payoutTransactionLog = this.transactionLogs.find(log =>
        !!log &&
        !!log.Type &&
        log.Type.Id === this.payoutTransactionLogTypeId &&
        log.IsPayoutTransLog === true &&
        log.IsPreliminary === false &&
        !!log.PayoutDate
      );
      this.transLogsRetrieved = true;
    } catch (err) {
      console.error('Error fetching transaction logs:', err);
      this.transactionLogs = [];
      this.payoutTransactionLog = undefined;
      this.transLogsRetrieved = false;
      throw err;
    }
  }

  changeValue(value) {

    this.InvoiceFeePaidByCustomer = value.checked;
    this.invoice.InvoiceFeePaidByCustomer = this.InvoiceFeePaidByCustomer;
  }

  sendMessage(message: string) {
    this.invoiceService.sendMessage(message, this.id)
      .subscribe(
        response => this.messageSent(response),
        error => console.log(error));
  }

  messageSent(message: any) {
    this.invoice.Message = undefined;
    this.invoice.Messages.push(message);
  }

  currencyChanged() {
    for (var i = 0; i < this.currencies.length; i++) {
      var curr = this.currencies[i];
      if (curr.Id == this.invoice.Currency.Id) {
        this.invoice.Currency.Name = curr.Name;
      }
    }
  }

  openInvoiceAdminDialog(): void {
    if (!this.invoice || !this.invoice.Id) {
      return;
    }

    this.invoiceService.getInvoice(this.invoice.Id)
      .subscribe(
        response => this.launchInvoiceAdminDialog(response),
        error => console.log(error));
  }

  private launchInvoiceAdminDialog(invoice: IInvoice): void {
    const config = {
      disableClose: false,
      panelClass: 'custom-overlay-pane-class',
      hasBackdrop: true,
      backdropClass: '',
      width: '900px',
      height: '80%',
      data: invoice
    };

    const dialogRef = this.dialog.open(InvoiceAdminDialogComponent, config);

    dialogRef.afterClosed().subscribe(() => {
      this.isLoading = true;
      this.loadInvoice(invoice.Id);
    });
  }

  loadInvoice(id: number) {
    if (this.scrollToPayoutAfterSave !== id) this.scrollToPayoutAfterSave = null;
    if (this.payoutBeforeSave?.invoiceId !== id) this.payoutBeforeSave = null;
    this.isLoading = true;
    this.isViewReady = false;
    this.payoutChecksComplete = false;
    this.hasPreviousPensionSaving = false;
    this.pensionSavingsMessage = "";
    this.transactionLogs = [];
    this.payoutTransactionLog = undefined;
    this.displayedPayoutName = '';
    this.transLogsRetrieved = false;
    this.tempYouthCalculationUpdated = false;

    this.invoiceService.getInvoiceShareTypes()
      .subscribe(
        response => this.invoiceShareTypes = response,
        error => console.log(error));

    this.invoiceService.getInvoice(id)
      .subscribe(
        response => this.onGetInvoiceCompleted(response),
        error => {
          console.log(error);
          this.scrollToPayoutAfterSave = null;
          this.isLoading = false;
          this.isViewReady = false;
        });
  }

  loadCurrencies() {
    this.currencyService.getCurrencies()
      .subscribe(
        response => this.currencies = response,
        error => console.log(error));
  }

  loadEmployerTaxes() {
    this.employerTaxService.getEmployerTaxes()
      .subscribe(
        response => {
          this.employerTaxes = response;

          // Historical percentages must come from the saved/database tax rates,
          // never be inferred from rounded monetary amounts.
          if (this.invoice && this.isInvoiceAlreadyPaidOut()) {
            this._calculateAllAmounts();
          }
        },
        error => console.log(error));
  }

  async checkPreviousPensionSavings(): Promise<void> {

    //Check if there is a previous pension savings payment on user
    try {
      const value = await firstValueFrom(
        this.transactionLogService
          .HasUserPensionSavings(this.invoice.UserSettings.Id)
      );
      this.onCheckPreviousPensionSavingsFinished(value);
    } catch (error) {
      this.onGetCompaniesError(error);
      throw error;
    }
  }

  onCheckPreviousPensionSavingsFinished(previousPensionSaving: ITransactionLog) {
    if (previousPensionSaving != null && previousPensionSaving.Id > 0) {
      this.hasPreviousPensionSaving = true;
      var pensionSavingsCompany = this.getPreviousPensionSavingsCompanies(previousPensionSaving);

      this.pensionSavingsMessage = "Medlem har fått pension tidigare. " + pensionSavingsCompany;
    }

    else if (previousPensionSaving == null) {
      this.hasPreviousPensionSaving = false;
    }
  }

  getPreviousPensionSavingsCompanies(previousPensionSaving: ITransactionLog): string {
    var pensionSavingsCompanies = previousPensionSaving.PensionSavingsCompanies || [];
    var companyNames = pensionSavingsCompanies
      .filter(company => company != null && company.Name != null && company.Name != "")
      .map(company => company.Name);

    if (companyNames.length == 0 && previousPensionSaving.PensionSavingsCompany != null) {
      companyNames.push(previousPensionSaving.PensionSavingsCompany.Name);
    }

    return companyNames.filter((name, index, names) => names.indexOf(name) == index).join(", ");
  }

  async checkZeroTaxAndLoadTaxes(): Promise<void> { 

    if (this.PartialTotalAmount != undefined &&
      (!this.zeroTaxChecked || this.zeroTaxBelowLimit !== (this.PartialTotalAmount < 1000))) {
      if (this.PartialTotalAmount < 1000) {
        await Promise.all([
          this.loadUserEmployerTax(true),
          this.loadUserMunicipalityTax(true),
          this.loadUserMunicipalityTaxOrdinary(true)
        ]);
      }
      else {
        await Promise.all([
          this.loadUserEmployerTax(false),
          this.loadUserMunicipalityTax(false),
          this.loadUserMunicipalityTaxOrdinary(false)
        ]);
      }

      this.zeroTaxChecked = true;
      this.zeroTaxBelowLimit = this.PartialTotalAmount < 1000;
    }
  }

  async onGetInvoiceCompleted(invoice: any) {
    try {
      this.originalSubtotalInputs = null;
      this.invoice = invoice;
      this.setDefaultPayoutDateForUnpaidInvoice();
      this.isLoading = true;
      this.isViewReady = false;
      this.payoutChecksComplete = false;
      this.zeroTaxChecked = false;
      this.taxAdjustmentThresholdStatus = undefined;

      this.setInvoiceFee();

      if (this.isInvoiceAlreadyPaidOut() && this.invoice.PayoutDate != null) {
        await this.getTransactionLogByInvoiceId(this.invoice.Id);
      }

      await this.loadLastExecutedTransaction();

    // Change: Ensure all initial data/factors are loaded before calling the main calculation
    await this.setUserWageGarnishmentsCurrentMonth(this.invoice.UserSettings.Id); // Sets current month garnishment data
    await this.loadPaidGrossSalaryInPayoutMonth();

      if (this.invoice.Deductions.length > 0) {
        await this.getHealthCareDeductionsTotalAmount();
      }

      // Ensure threshold status is loaded before final render and final calculation.
      if (await this._calculateAllAmounts() === false) {
        this.isViewReady = true;
        this.isLoading = false;
        return;
      }
      await this.loadTaxAdjustmentThresholdStatus();
      if (await this._calculateAllAmounts() === false) {
        this.isViewReady = true;
        this.isLoading = false;
        return;
      }

      if (this.PensionSavingsInclTax > 0) {
        await this.checkPreviousPensionSavings();
      }

      this.setDisplayedPayoutName();
      this.originalSubtotalInputs = this.getSubtotalInputs();
      this.payoutChecksComplete = true;
      this.isViewReady = true;

      //Default is that customer has paid their invoice fee
      if (this.invoice.PaymentDate == null) {
        this.InvoiceFeePaidByCustomer = true;
      }
      else {
        this.InvoiceFeePaidByCustomer = this.invoice.InvoiceFeePaidByCustomer;
      }

      this.setSenderText();
    } catch (error) {
      this.payoutChecksComplete = false;
      this.isViewReady = false;
      console.error('Failed to initialize invoice summary.', error);
    } finally {
      this.isLoading = false;
      this.changeDetectorRef.detectChanges();
      if (this.scrollToPayoutAfterSave === invoice.Id) {
        this.scrollToPayoutAfterSave = null;
        if (this.isViewReady && this.payoutChecksComplete && !this.calculationError) {
          this.payoutSection?.nativeElement.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      }
    }
  }

  setSenderText() {

    var invoice = this.invoice;

    var employmentNumber = invoice && invoice.UserSettings && invoice.UserSettings.EmploymentNumber
      ? invoice.UserSettings.EmploymentNumber
      : '';

    var invoiceNumberBase;
    if (invoice && invoice.SubInvoice) {
      invoiceNumberBase = this.getInvoiceNumberPart(invoice.InvoiceNumber || '');
    } else {
      invoiceNumberBase = invoice && invoice.InvoiceNumber ? invoice.InvoiceNumber : '';
    }

    var invoiceNumber = (invoice && invoice.ApprovedForExpress && invoice.ExpressPayOut)
      ? invoiceNumberBase + 'x'
      : invoiceNumberBase;

    this.textSender = (employmentNumber + ' ' + invoiceNumber).trim();

    this.payoutDayInfo = "";
    this.payoutDayInfoColor = 'inherit';
    this.payoutDaySelectedInfo = '';
    this.payoutDayWasAdjusted = false;

    const payoutDay = this.invoice.UserSettings.PayoutDay;
    const payoutType = this.invoice.UserSettings.PayoutType;
    const today = new Date();
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    let selectedPayoutDate: Date | null = null;
    if (payoutDay) {
      if (payoutType === 2) {
        const thisMonthDate = new Date(today.getFullYear(), today.getMonth(), payoutDay);
        const hasPassedThisMonth = thisMonthDate < todayDate;
        const targetMonthIndex = hasPassedThisMonth ? today.getMonth() + 1 : today.getMonth();
        const targetYear = targetMonthIndex > 11 ? today.getFullYear() + 1 : today.getFullYear();
        const normalizedMonthIndex = targetMonthIndex % 12;
        selectedPayoutDate = new Date(targetYear, normalizedMonthIndex, payoutDay);
      } else {
        selectedPayoutDate = new Date(today.getFullYear(), today.getMonth(), payoutDay);
      }
    }

    if (selectedPayoutDate && isNaN(selectedPayoutDate.getTime())) {
      selectedPayoutDate = null;
    }

    let payoutDate = selectedPayoutDate ? new Date(selectedPayoutDate.getTime()) : null;

    if (selectedPayoutDate && payoutType === 2) {
      this.payoutDaySelectedInfo = selectedPayoutDate.toLocaleDateString("sv-SE", {
        day: "numeric",
        month: "long"
      });
    }

    if (payoutDate && payoutType === 2) {
      payoutDate = this.getPreviousSwedishBankDay(payoutDate);
    }

    if (selectedPayoutDate && payoutDate) {
      this.payoutDayWasAdjusted = selectedPayoutDate.getTime() !== payoutDate.getTime();
    }

    const formattedDate = payoutDate ? payoutDate.toLocaleDateString("sv-SE", {
      day: "numeric",
      month: "long"
    }) : '';

    if (invoice.ExpressPayOut && invoice.ApprovedForExpress) {
      this.payoutDayInfo = "Express"
    }
    else if (!payoutDay || payoutDay === 0) {
      this.payoutDayInfo = "Löpande";
    }
    else {
      this.payoutDayInfo = `${formattedDate}`;
    }

    const isFixedDatePayout = payoutType === 2 && !!payoutDay;
    const isRowLightGrey = this.isInvoiceAlreadyPaidOut();
    if (isFixedDatePayout && !isRowLightGrey && payoutDay !== today.getDate()) {
      this.payoutDayInfoColor = 'red';
    }

  }

  private setDisplayedPayoutName(): void {
    //if (this.invoice?.PayoutReceiverCompany?.Name) {
    //  this.displayedPayoutName = this.invoice.PayoutReceiverCompany.Name;
    //  return;
    //}

    const employmentNumber = this.invoice?.UserSettings?.EmploymentNumber || '';
    const firstName = this.sanitizePayoutNamePart(this.invoice?.UserSettings?.FirstName);
    const lastName = this.sanitizePayoutNamePart(this.invoice?.UserSettings?.LastName);

    this.displayedPayoutName = [employmentNumber, firstName, lastName]
      .filter(part => !!part)
      .join(' ');
  }

  private sanitizePayoutNamePart(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const preservedLetters: Array<[string, string]> = [
      ['Å', '__SWEDISH_UPPER_A_RING__'],
      ['Ä', '__SWEDISH_UPPER_A_DIAERESIS__'],
      ['Ö', '__SWEDISH_UPPER_O_DIAERESIS__'],
      ['å', '__SWEDISH_LOWER_A_RING__'],
      ['ä', '__SWEDISH_LOWER_A_DIAERESIS__'],
      ['ö', '__SWEDISH_LOWER_O_DIAERESIS__']
    ];

    let sanitized = value;

    preservedLetters.forEach(([letter, placeholder]) => {
      sanitized = sanitized.split(letter).join(placeholder);
    });

    sanitized = sanitized
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/Æ/g, 'AE')
      .replace(/æ/g, 'ae')
      .replace(/Ø/g, 'O')
      .replace(/ø/g, 'o')
      .replace(/Œ/g, 'OE')
      .replace(/œ/g, 'oe')
      .replace(/Ð/g, 'D')
      .replace(/ð/g, 'd')
      .replace(/Þ/g, 'Th')
      .replace(/þ/g, 'th')
      .replace(/Ł/g, 'L')
      .replace(/ł/g, 'l');

    preservedLetters.forEach(([letter, placeholder]) => {
      sanitized = sanitized.split(placeholder).join(letter);
    });

    return sanitized
      .replace(/[^A-Za-zÅÄÖåäö -]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  async setGarnishment(): Promise<void> {
    this.activeWageGarnishment = this.getActiveAttachmentOfSalary(this.invoice?.PayoutDate);
    this.userHasWageGarnishment = !!this.activeWageGarnishment;

    if (!this.userHasWageGarnishment) {
      this.invoice.wageGarnishmentAmount = 0;
      // Change: No _calculateAllAmounts() or updateAmounts() call here. Calculations handled by _calculateAllAmounts.
      return;
    }

    const garnishment = this.activeWageGarnishment;
    const netPaid = this.netPaidThisMonth || 0;
    const deducted = this.userWageGarnishmentsCurrentMonth || 0;
    const attachmentAmount = garnishment.AttachmentAmount || 0;
    const reserved = garnishment.ReservedAmount || 0;
    const nettoLon = this.invoice.NettoLon || 0;
    const attReferenceNr = garnishment.ReferenceNumber;

    let personalNumberKfm = this.invoice.UserSettings.PersonalNumber;

    if (personalNumberKfm && personalNumberKfm.length === 12) {
      personalNumberKfm = personalNumberKfm.substring(2, 8) + '-' + personalNumberKfm.substring(8);
    }

    this.messageToKFM = attReferenceNr + " " + personalNumberKfm;

    const kvarAttDra = Math.max(0, attachmentAmount - deducted);
    if (kvarAttDra === 0) {
      this.invoice.wageGarnishmentAmount = 0;
      // Change: No _calculateAllAmounts() or updateAmounts() call here. Calculations handled by _calculateAllAmounts.
      return;
    }

    const fromDeductions = Math.min(this.deductionsEligibleForGarnishment || 0, kvarAttDra);
    const kvarEfterAvdrag = kvarAttDra - fromDeductions;

    const fromAllowances = Math.min(this.allowancesEligibleForGarnishment || 0, kvarEfterAvdrag);

    let possibleToDeduct = nettoLon + fromDeductions + fromAllowances;

    // Skydda resterande del av reserverat belopp (om inte uppnått)
    const skyddadDiff = Math.max(0, reserved - netPaid);
    possibleToDeduct = Math.max(0, possibleToDeduct - skyddadDiff);

    //Totalt utmätningsbart belopp denna faktura, redovisas enbart i vyn
    this.totalAssessableAmount = Math.round(fromDeductions + fromAllowances + nettoLon);

    const finalGarnishment = Math.min(possibleToDeduct, kvarAttDra);

    this.invoice.wageGarnishmentAmount = Math.round(finalGarnishment);
  }

  async recalculateGarnishment() {
    await this.setUserWageGarnishmentsCurrentMonth(this.invoice.UserSettings.Id);
    // Change: Trigger the main calculation method after garnishment data is updated
    if (await this._calculateAllAmounts() === false) { return; }

    //Make sure it is updated in view at payment, if more than one window is open at the same time
    this.garnishmentButtonUpdated = true;
    this.saveValidates();
  }

  async recalculateTempYouth(): Promise<void> {
    this.tempYouthCalculationUpdated = false;

    try {
      await this.loadPaidGrossSalaryInPayoutMonth();

      // Set this before the central calculation because that flow performs its
      // own final validation. Revert it if the refresh or calculation fails.
      this.tempYouthCalculationUpdated = true;
      if (await this._calculateAllAmounts() === false) {
        this.isViewReady = true;
        this.isLoading = false;
        return;
      }
    } catch (error) {
      this.tempYouthCalculationUpdated = false;
      this.saveValidates();
      throw error;
    } finally {
      this.changeDetectorRef.markForCheck();
    }
  }

  async onPayoutDateChanged(value: Date | string | null): Promise<void> {
    this.invoice.PayoutDate = value ? new Date(value) : null;
    this.paidGrossSalaryInPayoutMonthKey = "";
    this.tempYouthCalculationUpdated = false;
    this.zeroTaxChecked = false;
    this.taxAdjustmentThresholdStatus = undefined;
    this.saveValidates();
    if (await this._calculateAllAmounts() === false) { return; }
    await this.loadTaxAdjustmentThresholdStatus();
    if (await this._calculateAllAmounts() === false) { return; }
    this.payoutChecksComplete = true;
    this.isViewReady = true;
  }

  calculateAllowancesTotalAmount() {

    //Calculate allowances total amount
    this.milageTotalAmount = 0; // Reset before recalculation
    this.allowancesTotalAmount = 0; // Reset before recalculation
    this.allowancesEligibleForGarnishment = 0; // Reset before recalculation

    // Use the same row order as the log calculation, independent of API/database ordering.
    const allowances = this.invoice.Allowances.filter(allowance => !!allowance).sort((a, b) => a.Id - b.Id);
    for (var i = 0; i < allowances.length; i++) {

      var allowance = allowances[i];

      // Only include approved allowances in all sums
      if (!allowance || allowance.ApprovedByAdmin !== true) {
        continue;
      }

      // Addera endast allowances markerade som utmatningsbara
      if (allowance.IsGarnishable === true) {
        this.allowancesEligibleForGarnishment += Math.round(allowance.Sum);
      }

      if (allowance.AllowanceType.Id == '1') {
        this.milageTotalAmount += allowance.Sum;
      }
      else {

        this.allowancesTotalAmount += allowance.Sum;
      }

    }

    // Keep full precision per row and round each calculated total only once.
    this.milageTotalAmount = this.roundToWhole(this.milageTotalAmount);
    this.allowancesTotalAmount = this.roundToWhole(this.allowancesTotalAmount);

  }

  private roundToTwoDecimals(value: number): number {
    if (value === null || value === undefined || isNaN(value)) {
      return 0;
    }

    const absoluteValue = Math.abs(value);
    const roundedValue = Math.round(absoluteValue * 100) / 100;
    return Math.sign(value) * roundedValue;
  }

  private roundToWhole(value: number): number {
    if (value === null || value === undefined || isNaN(value)) {
      return 0;
    }

    // Match TransactionLogRepository's MidpointRounding.AwayFromZero.
    return Math.sign(value) * Math.round(Math.abs(value));
  }

  private resetPayoutAdjustedDeductions(): void {
    if (!this.invoice || !Array.isArray(this.invoice.Deductions)) {
      return;
    }

    this.invoice.Deductions.forEach(deduction => {
      if (deduction) {
        deduction.PayoutAdjustedAmount = undefined;
      }
    });
  }

  private applyPayoutAdjustedDeductions(): void {
    this.resetPayoutAdjustedDeductions();

    if (!this.invoice || !Array.isArray(this.invoice.Deductions) || this.invoice.Deductions.length === 0) {
      return;
    }

    const approvedDeductions = this.invoice.Deductions.filter(deduction => deduction && deduction.ApprovedByAdmin);
    if (approvedDeductions.length === 0) {
      return;
    }

    this.applyHealthCareCapAdjustments();

    const allowancesTotal = this.roundToTwoDecimals((this.milageTotalAmount || 0) + (this.allowancesTotalAmount || 0));
    const pensionSavingsTotal = this.roundToWhole(this.PensionSavingsInclTax || 0);
    const payoutLimit = this.roundToTwoDecimals(Math.max(0, (this.PartialTotalAmount || 0) - allowancesTotal - pensionSavingsTotal));
    const deductionRows = approvedDeductions.map((deduction, index) => ({
      deduction,
      amount: this.roundToTwoDecimals((deduction.PayoutAdjustedAmount !== null && deduction.PayoutAdjustedAmount !== undefined)
        ? deduction.PayoutAdjustedAmount
        : (deduction.Amount || 0)),
      index
    }));

    const totalAmount = this.roundToTwoDecimals(deductionRows.reduce((sum, row) => sum + row.amount, 0));

    if (totalAmount <= payoutLimit) {
      return;
    }

    let remainingOverage = this.roundToTwoDecimals(totalAmount - payoutLimit);

    deductionRows.sort((a, b) => {
      if (!!a.deduction.HealthCare !== !!b.deduction.HealthCare) {
        return a.deduction.HealthCare ? 1 : -1; // adjust health care deductions last
      }
      const diff = b.amount - a.amount;
      return diff !== 0 ? diff : a.index - b.index;
    });

    for (const row of deductionRows) {
      if (remainingOverage <= 0) {
        break;
      }

      if (row.amount <= 0) {
        continue;
      }

      const reduction = Math.min(remainingOverage, row.amount);
      row.deduction.PayoutAdjustedAmount = this.roundToTwoDecimals(row.amount - reduction);
      remainingOverage = this.roundToTwoDecimals(remainingOverage - reduction);
    }
  }

  private applyHealthCareCapAdjustments(): void {
    if (!this.invoice || !Array.isArray(this.invoice.Deductions)) {
      return;
    }

    const healthCareDeductions = this.invoice.Deductions
      .filter(deduction => deduction && deduction.ApprovedByAdmin && deduction.HealthCare);

    if (healthCareDeductions.length === 0) {
      return;
    }

    const currentTotal = this.roundToTwoDecimals(
      healthCareDeductions.reduce((sum, deduction) => sum + this.roundToTwoDecimals(deduction.Amount || 0), 0)
    );

    const excludeCurrent = this.isInvoiceAlreadyPaidOut() ? currentTotal : 0;
    const paidExcludingCurrent = Math.max(0, (this.healthCareDeductionsTotalAmount || 0) - excludeCurrent);
    const remaining = Math.max(0, 5000 - paidExcludingCurrent);

    if (currentTotal <= remaining) {
      return;
    }

    let remainingOverage = this.roundToTwoDecimals(currentTotal - remaining);
    const rows = healthCareDeductions.map((deduction, index) => ({
      deduction,
      amount: this.roundToTwoDecimals(deduction.Amount || 0),
      index
    }));

    rows.sort((a, b) => {
      const diff = b.amount - a.amount;
      return diff !== 0 ? diff : a.index - b.index;
    });

    for (const row of rows) {
      if (remainingOverage <= 0) {
        break;
      }

      if (row.amount <= 0) {
        continue;
      }

      const reduction = Math.min(remainingOverage, row.amount);
      row.deduction.PayoutAdjustedAmount = this.roundToTwoDecimals(row.amount - reduction);
      remainingOverage = this.roundToTwoDecimals(remainingOverage - reduction);
    }
  }

  private getDeductionAdjustedAmount(deduction: IDeduction): number {
    if (!deduction) {
      return 0;
    }

    if (deduction.PayoutAdjustedAmount !== null && deduction.PayoutAdjustedAmount !== undefined) {
      return deduction.PayoutAdjustedAmount;
    }

    return deduction.Amount || 0;
  }

  calculateDeductionsTotalAmount() { 
    this.DeductionsTotalAmount = 0; // Resetting total amount
    this.deductionsTotalAmountOriginal = 0;
    this.healthCareTotalAmountThisInvoice = 0;
    this.healthCareTotalAmountThisInvoiceOriginal = 0;
    this.deductionsEligibleForGarnishment = 0;
    this.netExpensesAdjustmentAmount = 0;

    if (this.invoice.Deductions.length > 0) {
      let originalDeductionsTotal = 0;
      let adjustedDeductionsTotal = 0;
      const deductions = [...this.invoice.Deductions].sort((a, b) => a.Id - b.Id);
      for (var i = 0; i < deductions.length; i++) {
        const deduction = deductions[i];

        //Add to total amount only if deduction is not denied by admin
        if (deduction.ApprovedByAdmin) {
          const adjustedAmount = this.getDeductionAdjustedAmount(deduction);
          const originalAmount = deduction.Amount || 0;
          originalDeductionsTotal += originalAmount;
          adjustedDeductionsTotal += adjustedAmount;

          //If deduction is approved and health care, chech the total amount of health care deductions
          if (deduction.HealthCare) {
            this.healthCareTotalAmountThisInvoice += Math.round(adjustedAmount);
            this.healthCareTotalAmountThisInvoiceOriginal += Math.round(originalAmount);
          }

          if (deduction.IsGarnishable === true)
            this.deductionsEligibleForGarnishment += adjustedAmount;

          this.DeductionsTotalAmount += adjustedAmount;

          if (this.healthCareDeductionsTotalAmount + this.healthCareTotalAmountThisInvoice > 5000) {
            this.healthCareAmountExceedesLimit = true;
            this.saveValidates()
          }
        }

      }

      this.approvedDeductions = this.invoice.Deductions.filter(deduction => deduction.ApprovedByAdmin);
      this.netExpensesAdjustmentAmount = this.roundToTwoDecimals(Math.max(0, originalDeductionsTotal - adjustedDeductionsTotal));
      this.DeductionsTotalAmount = this.roundToWhole(adjustedDeductionsTotal);
      this.deductionsTotalAmountOriginal = this.roundToWhole(originalDeductionsTotal);
      this.updateHealthCareDeductionsMessage();

    }
  }

  async getHealthCareDeductionsTotalAmount(): Promise<void> {
    let payoutYear: number;

    if (this.invoice.PayoutDate != null) {
      this.invoice.PayoutDate = new Date(this.invoice.PayoutDate);
    }

    if (this.invoice.PayoutDate) {
      payoutYear = this.invoice.PayoutDate.getFullYear();
    } else {
      payoutYear = new Date().getFullYear();
    }

    try {
      const healthCareAmount = await firstValueFrom(
        this.userService
          .getTotalAmountOfHealthCareDeduction(this.invoice.UserSettings.Id, payoutYear)
      );
      this.healthCareTotalAmountLoaded(healthCareAmount);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  healthCareTotalAmountLoaded(healthCareAmount: number) {
    this.healthCareDeductionsTotalAmount = healthCareAmount;
    this.updateHealthCareDeductionsMessage();
  }

  private updateHealthCareDeductionsMessage(): void {
    const currentInvoiceHealthCare = this.healthCareTotalAmountThisInvoiceOriginal || 0;
    const excludeCurrent = this.isInvoiceAlreadyPaidOut() ? currentInvoiceHealthCare : 0;
    const paidExcludingCurrent = Math.max(0, (this.healthCareDeductionsTotalAmount || 0) - excludeCurrent);
    this.healthCareDeductionsTotalAmountExcludingCurrent = this.roundToWhole(paidExcludingCurrent);
    this.healthCareDeductionsMessage = "Tidigare utbetalt för friskvård innevarande år (exkl denna faktura): " + this.healthCareDeductionsTotalAmountExcludingCurrent + " SEK.";
  }

  async loadUserEmployerTax(checkZeroTax: boolean = false): Promise<void> {
    try {
      const tax = await firstValueFrom(
        this.userService
          .getUserEmployerTax(this.invoice.UserSettings.Id, checkZeroTax, this.invoice.PayoutDate)
      );
      this.employerTaxLoaded(tax);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  employerTaxLoaded(tax: any) {
    this.invoice.EmployerTaxType = tax;
    // The initial option list contains this year's rates. Keep a returned
    // historical rate visible when the payout date belongs to another year.
    if (tax && tax.Id && !this.employerTaxes.some(item => item.Id === tax.Id)) {
      this.employerTaxes = [...this.employerTaxes, tax];
    }
  }

  async loadPaidGrossSalaryInPayoutMonth(): Promise<void> {
    this.paidGrossSalaryInPayoutMonth = 0;
    this.paidGrossSalaryInPayoutMonthKey = "";

    if (!this.invoice || !this.invoice.UserSettings || !this.invoice.UserSettings.Id || !this.invoice.PayoutDate) {
      return;
    }

    const payoutDate = new Date(this.invoice.PayoutDate);
    const excludeInvoiceId = this.invoice.Id > 0 ? this.invoice.Id : 0;
    this.paidGrossSalaryInPayoutMonthKey = this.getPayoutMonthKey(payoutDate, excludeInvoiceId);

    try {
      const response = await firstValueFrom(
        this.userService.getUserPayoutGrossSalaryInMonth(
          this.invoice.UserSettings.Id,
          payoutDate,
          excludeInvoiceId > 0 ? excludeInvoiceId : undefined
        )
      );

      this.paidGrossSalaryInPayoutMonth = Number(response && response.grossSalary) || 0;
    } catch (error) {
      console.log(error);
      this.paidGrossSalaryInPayoutMonth = 0;
      throw error;
    }
  }

  private async ensurePaidGrossSalaryInPayoutMonthLoaded(): Promise<void> {
    if (!this.invoice || !this.invoice.PayoutDate) {
      this.paidGrossSalaryInPayoutMonth = 0;
      this.paidGrossSalaryInPayoutMonthKey = "";
      return;
    }

    const payoutDate = new Date(this.invoice.PayoutDate);
    const excludeInvoiceId = this.invoice.Id > 0 ? this.invoice.Id : 0;
    const key = this.getPayoutMonthKey(payoutDate, excludeInvoiceId);

    if (this.paidGrossSalaryInPayoutMonthKey != key) {
      await this.loadPaidGrossSalaryInPayoutMonth();
    }
  }

  private getPayoutMonthKey(payoutDate: Date, excludeInvoiceId: number): string {
    if (!payoutDate || isNaN(payoutDate.getTime())) {
      return "";
    }

    return payoutDate.getFullYear() + "-" + payoutDate.getMonth() + "-" + excludeInvoiceId;
  }

  async loadUserMunicipalityTax(checkZeroTax: boolean = false): Promise<void> {
    try {
      const tax = await firstValueFrom(
        this.userService
          .getUserMunicipalityTax(this.invoice.PayoutDate, this.invoice.UserSettings.Id, checkZeroTax)
      );
      this.municipalityTaxLoaded(tax);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async loadUserMunicipalityTaxOrdinary(checkZeroTax: boolean = false): Promise<void> {
    try {
      const tax = await firstValueFrom(
        this.userService
          .getUserMunicipalityTax(this.invoice.PayoutDate, this.invoice.UserSettings.Id, checkZeroTax, true)
      );
      this.ordinaryMunicipalityTaxLoaded(tax);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  municipalityTaxLoaded(tax: any) {
    //this.invoice.UserSettings.Municipality.Tax = tax;
    this.municipalityTaxFactor = tax;
  }

  ordinaryMunicipalityTaxLoaded(tax: any) {
    this.ordinaryMunicipalityTaxFactor = tax;
  }

  loadUserNumberOfInvoices(userId) {
    this.userService.getUserNumberOfInvoices(userId)
      .subscribe(
        numberOfInvoices => this.numberOfInvoicesLoaded(numberOfInvoices),
        error => console.log(error));
  }

  numberOfInvoicesLoaded(numberOfInvoices: number) {

    this.numberOfInvoices = numberOfInvoices;
  }

  async loadLastExecutedTransaction(): Promise<void> {
    try {
      const lastPaymentLog = await firstValueFrom(
        this.transactionLogService
          .getLastExecutedTransactionByUserId(this.invoice.UserSettings.Id)
      );
      this.lastPayoutLoaded(lastPaymentLog);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  lastPayoutLoaded(lastPayoutLog: any) {

    this.lastPayoutLog = lastPayoutLog;
    //this.checkLastPayoutDateAndTaxes();

  }

  //checkIfYearOrMonthIsDifferent() {
  //  var lastPaymentMonth = new Date(this.lastPayoutLog.PayoutDate);
  //  var thisMonth = new Date();

  //  var lastPaymentYear = lastPaymentMonth.getFullYear();
  //  var lastPaymentMonthIndex = lastPaymentMonth.getMonth();

  //  var thisYear = thisMonth.getFullYear();
  //  var thisMonthIndex = thisMonth.getMonth();

  //  if (lastPaymentYear == thisYear && lastPaymentMonthIndex == thisMonthIndex) {
  //    this.taxChangedThisMonth = true;
  //  }

  //  if ((lastPaymentYear == thisYear && lastPaymentMonthIndex > thisMonthIndex) || lastPaymentYear > thisYear) {
  //    this.lastPaymentIsNextMonth = true;
  //  }
  //}

  //checkLastPayoutDateAndTaxes() {
  //  var empMessage = "";
  //  var munMessage = "";
  //  var monthInfo = "";
  //  var lastEmployerTax = this.lastPayoutLog.EmployerTaxType.Tax;
  //  var lastMunicipalityTax = this.lastPayoutLog.MunicipalityTax;
  //  var payoutDate = new Date(this.lastPayoutLog.PayoutDate + 'Z').toISOString().split('T')[0];
  //  var taxChanged = false;

  //  //If last paid invoice is the same as current invoice, there are no other payments
  //  if (this.lastPayoutLog.InvoiceId == this.invoice.Id) {
  //    this.lastPayoutMessage = "Denna faktura är redan utbetald och är medlemmens senaste";
  //    monthInfo = "";
  //  }
  //  else {
  //    if (lastEmployerTax != this.invoice.EmployerTaxType.Tax) {
  //      empMessage = "AGA skiljer sig från senaste utbet: " + (lastEmployerTax * 100).toFixed(2) + " %. ";
  //      taxChanged = true;
  //    }
  //    else {
  //      empMessage = "";
  //    }

  //    if (lastMunicipalityTax != this.municipalityTaxRounded) {
  //      munMessage = "Kommunskatten skiljer sig mot senaste utbet: " + (lastMunicipalityTax * 100).toFixed(2) + " %. ";
  //      taxChanged = true;
  //    }
  //    else {
  //      munMessage = "";
  //    }

  //    //Check if last payment was current month or before. Only warn if same month.
  //    this.checkIfYearOrMonthIsDifferent();


  //    //If tax changed, show if it is same month or not
  //    if (taxChanged) {
  //      if (this.taxChangedThisMonth) {
  //        monthInfo = "<br>Senaste utbet: " + payoutDate + ". OBS! Innevarande månad."
  //      }
  //      else {
  //        monthInfo = "<br>Senaste utbet: " + payoutDate + ". Ej innevarande månad."
  //      }
  //    }

  //    if (this.lastPaymentIsNextMonth) {
  //      monthInfo = "Senaste utbetalningen är schemalagd till en senare månad: " + payoutDate;
  //      this.taxChangedThisMonth = true;
  //    }

  //    this.lastPayoutMessage = munMessage + " " + empMessage + monthInfo;
  //  }
  //}

  saveValidates() {
    if (this.calculationError) {
      this.saveValid = false;
      this.saveMessage = this.calculationError;
      return;
    }

    if (this.pensionValidationMessage) {
      this.saveMessage = this.pensionValidationMessage;
      this.saveValid = false;
    }
    else if (this.invoice.Status.TechnicalName == "Draft" || this.invoice.Status.TechnicalName == "Deleted" || this.invoice.Status.TechnicalName == "UnderReview" || this.invoice.Status.TechnicalName == "Paused") {
      this.saveMessage = "Fakturans status är " + this.invoice.Status.Name;
      this.saveValid = false;
    }
    else if (this.invoice.HasUnhandledDeductions) {
      this.saveMessage = "Det finns ohanterade avdrag";
      this.saveValid = false;
    }
    else if (this.invoice.HasUnhandledAllowances) {
      this.saveMessage = "Det finns ohanterade reseersättningar";
      this.saveValid = false;
    }
    else if (this.healthCareAmountExceedesLimit) {
      this.saveMessage = "Friskvårdsavdragen överstiger gränsen";
      this.saveValid = false;
    }
    else if (this.userHasWageGarnishment && !this.garnishmentButtonUpdated) { 
      this.saveMessage = "Du behöver uppdatera beräkning för utmätning";
      this.saveValid = false;
    }
    else if (!this.isInvoiceAlreadyPaidOut() && this.invoice.EmployerTaxType && this.invoice.EmployerTaxType.Name == 'TempYouth' && !this.tempYouthCalculationUpdated) {
      this.saveMessage = "Du behöver uppdatera TempYouth-beräkningen";
      this.saveValid = false;
    }
    else {
      this.saveMessage = "";
      this.saveValid = true;
    }
  }

  // Change: Renamed updateAmounts to _calculateAllAmounts to signify it's the main orchestrator
  async _calculateAllAmounts() {
    this.calculationError = '';
    this.saveValid = false;
    try {
    this.invoice.BruttoLon = 0;
    this.invoice.NettoLon = 0;
    this.payoutEmployerTax = 0;
    await this.ensurePaidGrossSalaryInPayoutMonthLoaded();

    // Change: Ensure dependent calculations are performed BEFORE the main financial calculations
    this.calculateAllowancesTotalAmount();
    await this.getServiceFee();

    var totalVatAmount = this.invoice.TotalVatAmount;

    if (this.invoice.Currency.Name != "SEK") { 
      totalVatAmount = this.invoice.TotalVatAmount * this.invoice.ExchangeRateInvoiceSent;
    }

    //Add all fees
    this.invoice.FeesTotalAmount =
      this.roundToTwoDecimals(
        (
          this.InvoiceFeeMember +
          this.InvoiceFeeReceiver +
          this.invoice.ExchangeFee +
          this.invoice.KronofogdenFee +
          this.invoice.ReminderFee +
          this.invoice.ServiceFee +
          this.invoice.InkassoFee +
          this.invoice.CustomFee
        )
      );

    //Partial total amount from which payout is calculated
    this.PartialTotalAmount = this.roundToTwoDecimals(this.invoice.PaidTotal - totalVatAmount - this.invoice.FeesTotalAmount + this.invoice.ManualDiscount);

    //Check if zero tax should be used and get correct tax calculation
    await this.checkZeroTaxAndLoadTaxes();

    // Percentage pension uses the amount remaining after net expenses. A previous
    // pension calculation must not reduce the expense budget on the next edit.
    this.PensionSavingsInclTax = this.invoice.PensionSavingsFactor
      ? 0
      : this.invoice.PensionSavingsAmount * (1 + this.pensionSavingsTaxFactor);
    this.applyPayoutAdjustedDeductions();
    this.calculateDeductionsTotalAmount();

    //Makes sure municiplaity tax always is calculated with 2 decimals, even if 3 in db table
    // Use temporary tax if present instead of municipality standard tax

    if (this.invoice.Type != null && this.invoice.Type.TechnicalName == "CommissionCashInvoice") {
      this.municipalityTaxRounded = 0;
    }
    else if (this.invoice.UserSettings.TaxAdjustments != null && this.invoice.UserSettings.TaxAdjustments.length > 0) {
      this.municipalityTaxRounded = parseFloat(this.municipalityTaxFactor.toFixed(4));
      if (this.invoice.UserSettings.TaxAdjustments[0].UnhandledByAdmin) {
        this.hasUnhandledTaxAdjustments = true;
      }
    }
    else {
      this.municipalityTaxRounded = parseFloat(this.municipalityTaxFactor.toFixed(4));
    }
    
    //Total amount of expenses
    this.invoice.ExpensesTotalAmount = (this.DeductionsTotalAmount + this.milageTotalAmount + this.allowancesTotalAmount);
    this.expensesTotalAmountOriginalRounded = this.roundToWhole(this.deductionsTotalAmountOriginal + this.milageTotalAmount + this.allowancesTotalAmount);
    this.expensesTotalAmountRounded = this.roundToWhole(this.invoice.ExpensesTotalAmount);



    // The editable view always calculates from the current inputs. Saved payout
    // amounts are displayed separately in the transaction-log table.
    this.updatePercentagePensionSavingsAmount();
    this.pensionSavingsTaxAmount = (this.invoice.PensionSavingsAmount * this.pensionSavingsTaxFactor);
    this.PensionSavingsInclTax = (this.invoice.PensionSavingsAmount + this.pensionSavingsTaxAmount);

    //Amount from which employer tax is deducted
    this.PartialAmountExclNetExpenses = (this.PartialTotalAmount - this.invoice.ExpensesTotalAmount - this.PensionSavingsInclTax);
    if (this.PartialAmountExclNetExpenses < 0) {
      this.PartialAmountExclNetExpenses = 0;
    }

    const employerTaxBreakdown = this.calculateEmployerTaxBreakdown(this.PartialAmountExclNetExpenses);
    this.invoice.BruttoLon = employerTaxBreakdown.grossSalary;
    this.invoice.ArbetsgivarAvgift = employerTaxBreakdown.employerTaxAmount;

    //How much municipality tax is paid in SEK
    const ordinaryMunicipalityTaxRounded = this.ordinaryMunicipalityTaxFactor != null
      ? parseFloat(this.ordinaryMunicipalityTaxFactor.toFixed(4))
      : this.municipalityTaxRounded;

    const applyThresholdSplit =
      this.taxAdjustmentThresholdStatus &&
      this.taxAdjustmentThresholdStatus.HasActiveAdjustment &&
      (this.taxAdjustmentThresholdStatus.MaxAmount || 0) > 0;

    if (applyThresholdSplit) {
      const paidTotal = this.taxAdjustmentThresholdStatus.PaidTotal || 0;
      const remaining = Math.max(0, (this.taxAdjustmentThresholdStatus.MaxAmount || 0) - paidTotal);
      const adjustedPart = Math.min(this.invoice.BruttoLon, remaining);
      const ordinaryPart = Math.max(0, this.invoice.BruttoLon - adjustedPart);
      this.PayoutMunicipalityTax = (adjustedPart * this.municipalityTaxRounded) + (ordinaryPart * ordinaryMunicipalityTaxRounded);
    }
    else {
      this.PayoutMunicipalityTax = (this.invoice.BruttoLon * this.municipalityTaxRounded);
    }

    //Calculates net salary
    this.invoice.NettoLon = (this.invoice.BruttoLon - this.PayoutMunicipalityTax);

    //Rounds payout up to closes int
    //this.TotalPayout = Math.round(this.invoice.PayOutTotal);
    this.TotalPayout = this.invoice.PayOutTotal;

    this.TotalInvoiceAmount = this.invoice.TotalInvoiceAmount;

    //Calculates the total payout amount
    this.invoice.PayOutTotal = this.roundToWhole(this.invoice.NettoLon + this.invoice.ExpensesTotalAmount);

    //If net expenses are exceeding the partial total amount, only the partial total amount can be paid
    if (this.invoice.ExpensesTotalAmount > this.PartialTotalAmount) {
      this.invoice.PayOutTotal = this.roundToWhole(this.PartialTotalAmount);
    }

    // Change: Calculate garnishment here, AFTER NettoLon and PayOutTotal are determined
    await this.setGarnishment();

    if (this.invoice.wageGarnishmentAmount > 0) {
      this.invoice.PayOutTotal = this.roundToWhole(this.invoice.PayOutTotal - this.invoice.wageGarnishmentAmount);
    }

    this.invoice.BruttoLon = this.roundToWhole(this.invoice.BruttoLon);
    this.invoice.NettoLon = this.roundToWhole(this.invoice.NettoLon);
    this.PayoutMunicipalityTax = this.roundToWhole(this.PayoutMunicipalityTax);
    this.PartialAmountExclNetExpenses = this.roundToWhole(this.PartialAmountExclNetExpenses);
    this.PensionSavingsInclTax = this.roundToWhole(this.PensionSavingsInclTax);
    this.invoice.ArbetsgivarAvgift = this.PartialAmountExclNetExpenses - this.invoice.BruttoLon;
    // Keep the fixed premium's precision for the next calculation and save.
    this.pensionSavingsTaxAmount = this.roundToWhole(this.pensionSavingsTaxAmount);

    if (this.invoice.ExchangeRateInvoiceSent > 0 && this.invoice.ExchangeRateInvoicePaid == 0) {
      await this.updateExchangeRatePaid();
    }

    // Change: These are now part of the central calculation flow, not triggered from separate methods
    await this.loadInvoiceDetailsAndPopulateTable();
    this.saveValidates();
    this.changeDetectorRef.markForCheck();
    //this.checkLastPayoutDateAndTaxes();
    return true;
    } catch (error) {
      this.calculationError = error?.error?.code === 'MissingMunicipalityTaxHistory'
        ? error.error.message
        : 'Beräkningen kunde inte slutföras. Kontrollera skatteuppgifterna för valt utbetalningsdatum och försök igen. Underlaget kan inte sparas innan beräkningen är klar.';
      this.zeroTaxChecked = false;
      this.invoice.BruttoLon = null;
      this.invoice.NettoLon = null;
      this.invoice.PayOutTotal = null;
      this.invoice.ArbetsgivarAvgift = null;
      this.PayoutMunicipalityTax = null;
      this.PartialAmountExclNetExpenses = null;
      this.PensionSavingsInclTax = null;
      this.pensionSavingsTaxAmount = null;
      this.saveValidates();
      this.changeDetectorRef.markForCheck();
      return false;
    }
  }

  async updateExchangeRatePaid() {
    this.invoice.ExchangeRateInvoicePaid = (this.invoice.PaidTotal / this.invoice.TotalInvoiceAmountIncVat).toFixed(6);
  }

  get pensionShareOfGrossSalaryPercent(): number | null {
    const pension = Number(this.invoice?.PensionSavingsAmount) || 0;
    const grossSalary = Number(this.invoice?.BruttoLon) || 0;
    if (pension === 0) {
      return 0;
    }
    return grossSalary > 0 ? pension / grossSalary * 100 : null;
  }

  get displayedPensionSavingsAmount(): number {
    return this.roundToWhole(this.invoice?.PensionSavingsAmount || 0);
  }

  get payoutDifference() {
    const logs = (this.transactionLogs || []).filter(log => log && log.IsPayoutTransLog &&
      ['PayoutSalary', 'PreliminaryPayout'].includes(log.Type?.TechnicalName));
    if (!logs.some(log => log.IsPreliminary === false)) return null;
    const before = this.payoutBeforeSave;
    if (before && before.invoiceId === this.invoice?.Id) {
      const created = logs.filter(log => !log.IsPreliminary && !before.logIds.includes(log.Id))
        .sort((a, b) => b.Id - a.Id)[0];
      if (created) {
        const difference = this.comparePayoutAmounts(created, before.amounts, true);
        if (difference) return difference;
      }
    }
    if (this.calculationError) return null;
    // The API only returns active logs. Prefer an executed payout over a preliminary one.
    const log = [...logs].sort((a, b) => Number(a.IsPreliminary) - Number(b.IsPreliminary) ||
      new Date(b.Created).getTime() - new Date(a.Created).getTime() || b.Id - a.Id)[0];
    return this.comparePayoutAmounts(log, this.capturePayoutAmounts());
  }

  private capturePayoutAmounts(): Partial<ITransactionLog> {
    return {
      TotalPayout: this.invoice?.PayOutTotal, PartialTotalAmount: this.PartialTotalAmount,
      InvoiceFee: this.InvoiceFeeReceiver, InvoiceFeeMember: this.InvoiceFeeMember,
      ServiceFee: this.invoice?.ServiceFee, ExchangeFee: this.invoice?.ExchangeFee,
      ReminderFee: this.invoice?.ReminderFee, InkassoFee: this.invoice?.InkassoFee,
      KronofogdenFee: this.invoice?.KronofogdenFee, CustomFee: this.invoice?.CustomFee,
      ManualDiscount: this.invoice?.ManualDiscount,
      PensionSavings: this.displayedPensionSavingsAmount, PensionSavingsTaxAmount: this.pensionSavingsTaxAmount,
      GrossSalary: this.invoice?.BruttoLon, EmployerTaxAmount: this.invoice?.ArbetsgivarAvgift,
      MunicipalityTaxAmount: this.PayoutMunicipalityTax, NetSalary: this.invoice?.NettoLon,
      DeductionsTotalAmount: this.DeductionsTotalAmount, MileageTotalAmount: this.milageTotalAmount,
      AllowancesTotalAmount: this.allowancesTotalAmount, AttachmentOfSalaryAmount: this.invoice?.wageGarnishmentAmount
    };
  }

  private comparePayoutAmounts(log: ITransactionLog, amounts: Partial<ITransactionLog>, beforeSave = false) {
    if (!log || !Number.isFinite(log.TotalPayout) || !Number.isFinite(amounts.TotalPayout)) return null;
    const difference = this.roundToTwoDecimals(amounts.TotalPayout - log.TotalPayout);
    const fields = [
      ['InvoiceFee', 'Fakturaavgift (kund)'], ['InvoiceFeeMember', 'Fakturaavgift (medlem)'],
      ['ServiceFee', 'SAMpoolen-avgift'], ['ExchangeFee', 'Bankavgift'],
      ['ReminderFee', 'Påminnelseavgift'], ['InkassoFee', 'Inkassoavgift'],
      ['KronofogdenFee', 'Avgift Kronofogden'], ['CustomFee', 'Manuell avgift'],
      ['ManualDiscount', 'Manuell rabatt eller gåva'],
      ['PartialTotalAmount', 'Delsumma efter avgifter'], ['PensionSavings', 'Pensionspremie'],
      ['PensionSavingsTaxAmount', 'Pensionsskatt'], ['GrossSalary', 'Bruttolön'],
      ['EmployerTaxAmount', 'Arbetsgivaravgift'], ['MunicipalityTaxAmount', 'Inkomstskatt'],
      ['NetSalary', 'Nettolön'], ['DeductionsTotalAmount', 'Utlägg'],
      ['MileageTotalAmount', 'Milersättning'], ['AllowancesTotalAmount', 'Traktamente'],
      ['AttachmentOfSalaryAmount', 'Löneutmätning']
    ];
    const items = fields.map(([field, label]) => ({ label, saved: log[field], current: amounts[field] }))
      .filter(item => Number.isFinite(item.saved) && Number.isFinite(item.current) &&
        this.roundToTwoDecimals(item.current - item.saved) !== 0);
    if (difference === 0 && items.length === 0) return null;
    return { logId: log.Id, preliminary: log.IsPreliminary, saved: log.TotalPayout,
      current: amounts.TotalPayout, difference, items, beforeSave };
  }

  get pensionValidationMessage(): string {
    if (isPensionWithinLimit(Number(this.invoice?.PensionSavingsAmount ?? 0),
      Number(this.invoice?.BruttoLon), Number(this.invoice?.PensionSavingsFactor ?? 0))) {
      return '';
    }
    return 'Pensionsavsättningen får vara högst 35 % av den slutgiltiga bruttolönen, exklusive pensionsskatt. Kontrollera pensionsbeloppet innan du sparar.';
  }

  private updatePercentagePensionSavingsAmount(): void {
    if (!this.invoice || !this.invoice.PensionSavingsFactor || !this.invoice.EmployerTaxType) {
      return;
    }

    const selectedTax = this.invoice.EmployerTaxType;
    const normalTax = selectedTax.Name === 'TempYouth'
      ? (this.employerTaxes || []).find(t => t && t.Name === 'Normal' && (!selectedTax.Year || t.Year === selectedTax.Year))
      : null;
    this.invoice.PensionSavingsAmount = Math.round(calculatePension(
      this.PartialTotalAmount - this.invoice.ExpensesTotalAmount,
      this.invoice.PensionSavingsFactor, this.pensionSavingsTaxFactor, selectedTax.Tax,
      normalTax ? normalTax.Tax : null, Math.max(0, 25000 - this.paidGrossSalaryInPayoutMonth)));
  }

  setInvoiceFee() {
    if (this.invoice.FeePaidByReciever) {
      this.InvoiceFeeReceiver = this.invoice.InvoiceFee;
      this.InvoiceFeeMember = 0;
    }
    else {
      this.InvoiceFeeMember = this.invoice.InvoiceFee;
      this.InvoiceFeeReceiver = 0;
    }
  }

  isInvoicePayoutBlocked(): boolean {
    return ['Paired', 'Credited'].includes(this.invoice?.Status?.TechnicalName);
  }

  async save(invoice: any, sendEmail: boolean, updatePayoutDate: boolean = true) {
    if (updatePayoutDate && invoice.PayoutDate && this.isInvoicePayoutBlocked()) return;

    // Capture what the user saw before save itself recalculates and the page reloads.
    const displayedAmounts = Number.isFinite(this.invoice?.PayOutTotal) ? this.capturePayoutAmounts() : null;
    const previousLogIds = (this.transactionLogs || []).map(log => log.Id);

    this.isLoading = true;
    try {
      if (await this._calculateAllAmounts() === false) {
        this.isViewReady = true;
        this.isLoading = false;
        return;
      }
    } catch (error) {
      console.log(error);
      this.isLoading = false;
      this.changeDetectorRef.detectChanges();
      return;
    }

    // All save modes must validate the newly calculated pension, including payment-only saves.
    if (this.pensionValidationMessage) {
      this.saveValidates();
      this.isLoading = false;
      this.changeDetectorRef.detectChanges();
      return;
    }

    this.invoice.InvoiceFeePaidByCustomer = this.InvoiceFeePaidByCustomer;
    const thresholdMessage = (this.taxAdjustmentThresholdMessage || '').trim();
    const thresholdHeadline = thresholdMessage ? thresholdMessage.split('\n')[0].trim() : '';
    const splitDetails = (this.taxAdjustmentSplitDetails || '').trim();
    const taxAdjustmentInfo = thresholdHeadline
      ? (splitDetails ? `${thresholdHeadline}\n${splitDetails}` : thresholdHeadline)
      : splitDetails;
    invoice.TaxAdjustmentInfo = updatePayoutDate && this.invoice.PayoutDate && taxAdjustmentInfo ? taxAdjustmentInfo : null;

    this.isLoading = true;
    const beforeSave = updatePayoutDate && invoice.PayoutDate
      ? { invoiceId: invoice.Id, logIds: previousLogIds, amounts: displayedAmounts || this.capturePayoutAmounts() }
      : null;
    this.invoiceService.updateInvoiceSummary(invoice, sendEmail, true, updatePayoutDate)
      .subscribe(
        response => {
          if (beforeSave) this.payoutBeforeSave = beforeSave;
          this.scrollToPayoutAfterSave = updatePayoutDate ? invoice.Id : null;
          this.onSaved(response);
        },
        error => {
          console.log(error);
          this.isLoading = false;
          this.changeDetectorRef.detectChanges();
        });
  }

  onSaved(response: any) {
    //Reload the view when page is saved
    this.loadInvoice(this.invoice.Id);
  }

  getCompanies() {
    this.companyService.getMyCompanies()
      .subscribe(value => this.onGetCompaniesFinished(value),
        error => this.onGetCompaniesError(error)
      );
  }

  onGetCompaniesFinished(companies: any) {
    this.companies = companies;
  }

  onGetCompaniesError(error: any) {
  }

  getInvoiceNumberPart(invoiceNumber: string): string {
    if (invoiceNumber && invoiceNumber.includes('-')) {
      return invoiceNumber.split('-')[0];
    }
    return invoiceNumber;
  }

  async getServiceFee() {

    await this.loadGlobalServiceFee();

    if (!this.invoice.ServiceFeeUnlocked) {
      //If invoice is not paid, and member has custom service fee, use custom service fee, unless shared service fee
      if (this.invoice.ServiceFeeShare.Percentage != null && this.invoice.ServiceFeeShare.Percentage == 0) {

        if (this.invoice.UserSettings.HasCustomServiceFee && !this.invoice.ExpressPayOut && !this.isInvoiceAlreadyPaidOut()) {
          this.serviceFeeFactor = this.invoice.UserSettings.CustomServiceFee;

          var customServicePercent = this.invoice.UserSettings.CustomServiceFee * 100;

          this.ServiceFeeInfo = "Avtalad serviceavgift: " + customServicePercent + " %";
        }
      }
      else if (this.invoice.ServiceFeeShare.Percentage != null && this.invoice.ServiceFeeShare.IsActive == true) {
        var sharedServicePercent = this.invoice.ServiceFeeShare.Percentage;
        var parentServicePercent = this.invoice.ServiceFeeShare.InvoiceSenderServiceFeeFactor * 100;

        this.ServiceFeeInfo = "Andel: " + sharedServicePercent + " % av moderfakturans ordinarie serviceavgift: " + parentServicePercent + " %";
      }
      else {
        this.ServiceFeeInfo = "";
      }
    }
  }

  async loadGlobalServiceFee(): Promise<void> {
    var express = this.invoice.ExpressPayOut;

    try {
      const serviceFeeFactor = await firstValueFrom(
        this.invoiceService
          .getGlobalServiceFee(express)
      );
      this.onGetGlobalServiceFeeFinished(serviceFeeFactor);
    } catch (error) {
      this.onGetGlobalServiceFeeError(error);
      throw error;
    }
  }

  private async loadTaxAdjustmentThresholdStatus(): Promise<void> {
    this.taxAdjustmentThresholdExceeded = false;
    this.taxAdjustmentThresholdMessage = '';
    this.taxAdjustmentSplitDetails = '';

    if (!this.invoice || !this.invoice.UserSettings || !this.invoice.UserSettings.Id) {
      return;
    }

    const payoutLog = this.transactionLogs.find(log =>
      !!log &&
      !!log.Type &&
      log.Type.TechnicalName === 'PayoutSalary' &&
      log.IsPayoutTransLog === true &&
      log.IsPreliminary === false
    );

    const hasRegisteredPayout = !!this.invoice.PayoutDate && !!payoutLog;
    let referenceDate = this.invoice.PayoutDate ? new Date(this.invoice.PayoutDate) : new Date();

    if (hasRegisteredPayout && payoutLog.Created) {
      const payoutCreatedAt = new Date(payoutLog.Created);
      if (!isNaN(payoutCreatedAt.getTime())) {
        // "Hittills utbetalt" ska avse utbetalningar före denna fakturas utbetalningstidpunkt.
        referenceDate = new Date(payoutCreatedAt.getTime() - 1000);
      }
    }

    try {
      const status = await firstValueFrom(
        this.userService
          .getTaxAdjustmentThresholdStatus(
            this.invoice.UserSettings.Id,
            referenceDate,
            this.invoice.Id > 0 ? this.invoice.Id : undefined
          )
      );

      this.taxAdjustmentThresholdStatus = status;

      if (!status || !status.HasActiveAdjustment) {
        this.taxAdjustmentThresholdExceeded = false;
        this.taxAdjustmentThresholdMessage = '';
        this.taxAdjustmentSplitDetails = '';
        return;
      }

      const start = status.DateStart ? new Date(status.DateStart).toLocaleDateString('sv-SE') : '';
      const end = status.DateEnd ? new Date(status.DateEnd).toLocaleDateString('sv-SE') : '';
      const maxAmount = Math.round(status.MaxAmount || 0);
      const paidTotal = Math.round(status.PaidTotal || 0);
      const payoutLogGrossRaw = hasRegisteredPayout
        ? ((payoutLog && payoutLog.GrossSalary) || 0)
        : 0;
      const payoutLogGrossFallback = hasRegisteredPayout
        ? (((payoutLog && payoutLog.NetSalary) || 0) + ((payoutLog && payoutLog.MunicipalityTaxAmount) || 0))
        : 0;
      const currentGross = Math.round(
        hasRegisteredPayout
          ? (payoutLogGrossRaw > 0
            ? payoutLogGrossRaw
            : (payoutLogGrossFallback > 0 ? payoutLogGrossFallback : (this.invoice.BruttoLon || 0)))
          : (this.invoice.BruttoLon || 0)
      );
      const currentTotal = currentGross;
      const projectedTotal = Math.round(paidTotal + currentTotal);
      const exceededBeforeCurrent = paidTotal > maxAmount;
      const willExceed = projectedTotal > maxAmount;
      const remaining = Math.max(0, (status.MaxAmount || 0) - (status.PaidTotal || 0));
      const adjustedPart = Math.min(currentTotal, remaining);
      const ordinaryPart = Math.max(0, currentTotal - adjustedPart);
      const adjustedTaxFactor = this.municipalityTaxRounded != null
        ? this.municipalityTaxRounded
        : parseFloat((this.municipalityTaxFactor || 0).toFixed(4));
      const ordinaryTaxFactor = this.ordinaryMunicipalityTaxFactor != null
        ? parseFloat(this.ordinaryMunicipalityTaxFactor.toFixed(4))
        : adjustedTaxFactor;
      const adjustedTaxAmount = Math.round(adjustedPart * adjustedTaxFactor);
      const ordinaryTaxAmount = Math.round(ordinaryPart * ordinaryTaxFactor);
      const formatAmount = (value: number) => Math.round(value || 0).toLocaleString('sv-SE');
      const formatPercent = (value: number) => (value || 0).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const computedSplitDetails =
        `Skattefördelning för denna faktura:` +
        `\n- Andel med skattejämkning: ${formatAmount(adjustedPart)} kr. Skattesats: ${formatPercent(adjustedTaxFactor * 100)} %. Total skatt på den delen: ${formatAmount(adjustedTaxAmount)} kr.` +
        `\n- Andel med ordinarie skatt: ${formatAmount(ordinaryPart)} kr. Skattesats: ${formatPercent(ordinaryTaxFactor * 100)} %. Total skatt på den delen: ${formatAmount(ordinaryTaxAmount)} kr.`;
      const persistedSplitDetails = hasRegisteredPayout ? ((payoutLog.Info || '').trim()) : '';
      const splitDetails = currentTotal > 0 ? computedSplitDetails : (persistedSplitDetails || computedSplitDetails);
      this.taxAdjustmentSplitDetails = splitDetails;

      if (!exceededBeforeCurrent && !willExceed) {
        this.taxAdjustmentThresholdExceeded = false;
        this.taxAdjustmentThresholdMessage = '';
        return;
      }

      this.taxAdjustmentThresholdExceeded = true;

      if (exceededBeforeCurrent) {
        this.taxAdjustmentThresholdMessage =
          `Utbetald lön under skattejämkning (period ${start} - ${end}) har överstigit maxbeloppet ${maxAmount} kr. ` +
          `\nUtbetalt hittills (exkl denna faktura): ${paidTotal} kr. Denna faktura (bruttolön): ${currentTotal} kr. Totalt: ${projectedTotal} kr.` +
          `\n${splitDetails}`;
        return;
      }

      this.taxAdjustmentThresholdMessage =
        `Utbetalningen kommer att överskrida maxbeloppet ${maxAmount} kr för skattejämkning (period ${start} - ${end}). ` +
        `\nUtbetalt hittills: ${paidTotal} kr. Denna faktura (bruttolön): ${currentTotal} kr. Totalt: ${projectedTotal} kr.` +
        `\n${splitDetails}`;
    } catch (error) {
      this.taxAdjustmentThresholdStatus = undefined;
      this.taxAdjustmentThresholdExceeded = false;
      this.taxAdjustmentThresholdMessage = '';
      this.taxAdjustmentSplitDetails = '';
      throw error;
    }
  }

  onGetGlobalServiceFeeError(error: any) {

  }

  onGetGlobalServiceFeeFinished(serviceFeeFactor: any) {
    this.serviceFeeFactor = serviceFeeFactor;
  }

  getCustomer(id) {
    for (var i = 0; i < this.companies.length; i++) {
      if (this.companies[i].Id == this.invoice.Customer.Id) {
        //console.log(this.companies[i]);
        return JSON.parse(JSON.stringify(this.companies[i]));
      }
    }
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }

  employerTaxUpdated(taxId: number) {
    for (var i = 0; i < this.employerTaxes.length; i++) {
      if (this.employerTaxes[i].Id == taxId) {
        this.invoice.EmployerTaxType.Tax = this.employerTaxes[i].Tax;
      }
    }

    this._calculateAllAmounts();
  }

  private calculateEmployerTaxBreakdown(partialAmountExclNetExpenses: number): { grossSalary: number, employerTaxAmount: number } {
    this.employerTaxBreakdown = {
      isHistorical: false,
      hasTempYouthCalculation: false,
      hasSplit: false,
      monthlyLimit: 25000,
      paidGrossSalaryInPayoutMonth: 0,
      remainingTempYouthGrossSalary: 0,
      tempYouthGrossSalary: 0,
      tempYouthEmployerTaxAmount: 0,
      tempYouthTaxRate: 0,
      normalGrossSalary: 0,
      normalEmployerTaxAmount: 0,
      normalTaxRate: 0
    };

    const selectedTax = this.invoice && this.invoice.EmployerTaxType ? this.invoice.EmployerTaxType : null;

    if (!selectedTax || partialAmountExclNetExpenses <= 0) {
      return { grossSalary: 0, employerTaxAmount: 0 };
    }

    if (selectedTax.Name != 'TempYouth') {
      const grossSalary = partialAmountExclNetExpenses / (1 + selectedTax.Tax);
      return {
        grossSalary: grossSalary,
        employerTaxAmount: partialAmountExclNetExpenses - grossSalary
      };
    }

    const normalTax = (this.employerTaxes || []).find(t =>
      !!t &&
      t.Name == 'Normal' &&
      (!selectedTax.Year || t.Year == selectedTax.Year)
    );

    if (!normalTax) {
      const grossSalary = partialAmountExclNetExpenses / (1 + selectedTax.Tax);
      return {
        grossSalary: grossSalary,
        employerTaxAmount: partialAmountExclNetExpenses - grossSalary
      };
    }

    const tempYouthGrossSalaryLimit = 25000;
    const remainingTempYouthGrossSalary = Math.max(0, tempYouthGrossSalaryLimit - (this.paidGrossSalaryInPayoutMonth || 0));
    this.employerTaxBreakdown = {
      isHistorical: false,
      hasTempYouthCalculation: true,
      hasSplit: false,
      monthlyLimit: tempYouthGrossSalaryLimit,
      paidGrossSalaryInPayoutMonth: this.paidGrossSalaryInPayoutMonth || 0,
      remainingTempYouthGrossSalary: remainingTempYouthGrossSalary,
      tempYouthGrossSalary: 0,
      tempYouthEmployerTaxAmount: 0,
      tempYouthTaxRate: selectedTax.Tax,
      normalGrossSalary: 0,
      normalEmployerTaxAmount: 0,
      normalTaxRate: normalTax.Tax
    };

    if (remainingTempYouthGrossSalary <= 0) {
      const normalGrossSalary = partialAmountExclNetExpenses / (1 + normalTax.Tax);
      this.employerTaxBreakdown.normalGrossSalary = normalGrossSalary;
      this.employerTaxBreakdown.normalEmployerTaxAmount = partialAmountExclNetExpenses - normalGrossSalary;
      return {
        grossSalary: normalGrossSalary,
        employerTaxAmount: partialAmountExclNetExpenses - normalGrossSalary
      };
    }

    const tempYouthCostLimit = remainingTempYouthGrossSalary * (1 + selectedTax.Tax);
    if (partialAmountExclNetExpenses <= tempYouthCostLimit) {
      const tempYouthGrossSalary = partialAmountExclNetExpenses / (1 + selectedTax.Tax);
      this.employerTaxBreakdown.tempYouthGrossSalary = tempYouthGrossSalary;
      this.employerTaxBreakdown.tempYouthEmployerTaxAmount = partialAmountExclNetExpenses - tempYouthGrossSalary;
      return {
        grossSalary: tempYouthGrossSalary,
        employerTaxAmount: partialAmountExclNetExpenses - tempYouthGrossSalary
      };
    }

    const normalPartCost = partialAmountExclNetExpenses - tempYouthCostLimit;
    const normalGrossSalary = normalPartCost / (1 + normalTax.Tax);
    const tempYouthEmployerTaxAmount = tempYouthCostLimit - remainingTempYouthGrossSalary;
    const normalEmployerTaxAmount = normalPartCost - normalGrossSalary;
    const grossSalary = remainingTempYouthGrossSalary + normalGrossSalary;
    this.employerTaxBreakdown = {
      isHistorical: false,
      hasTempYouthCalculation: true,
      hasSplit: true,
      monthlyLimit: tempYouthGrossSalaryLimit,
      paidGrossSalaryInPayoutMonth: this.paidGrossSalaryInPayoutMonth || 0,
      remainingTempYouthGrossSalary: remainingTempYouthGrossSalary,
      tempYouthGrossSalary: remainingTempYouthGrossSalary,
      tempYouthEmployerTaxAmount: tempYouthEmployerTaxAmount,
      tempYouthTaxRate: selectedTax.Tax,
      normalGrossSalary: normalGrossSalary,
      normalEmployerTaxAmount: normalEmployerTaxAmount,
      normalTaxRate: normalTax.Tax
    };

    return {
      grossSalary: grossSalary,
      employerTaxAmount: partialAmountExclNetExpenses - grossSalary
    };
  }

  toFormattedDate(iso: string) {
    const date = new Date(iso);
    var d = `${date.getFullYear()}-${(date.getMonth() + 1).toString().length == 1 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1}-${date.getDate().toString().length == 1 ? ("0" + date.getDate().toString()) : date.getDate().toString()}`;
    if (d == '1970-01-01')
      return undefined;
    return d;
  }

  async loadInvoiceDetailsAndPopulateTable() {
    this.tableRows = []; // Clear previous rows
    var arbGivAvg = 0;
    var bruttoLon = 0;
    var inkSkatt = 0;
    var nettoLonBelopp = 0;
    var payoutTotal = 0;

    this.payoutTransactionLog = null;

    if (this.invoice.PayoutDate != null) {
      this.payoutTransactionLog = this.transactionLogs.find(log =>
        !!log &&
        !!log.Type &&
        log.Type.Id === this.payoutTransactionLogTypeId &&
        log.IsPayoutTransLog === true &&
        log.IsPreliminary === false &&
        !!log.PayoutDate
      );

      if (this.payoutTransactionLog) {
        arbGivAvg = this.payoutTransactionLog.EmployerTaxAmount;
        bruttoLon = this.payoutTransactionLog.GrossSalary;
        inkSkatt = this.payoutTransactionLog.MunicipalityTaxAmount;
        nettoLonBelopp = this.payoutTransactionLog.NetSalary;
        var garnishmentAmount = this.payoutTransactionLog.AttachmentOfSalaryAmount;
        payoutTotal = this.payoutTransactionLog.TotalPayout;
      }
    }

    if (!this.payoutTransactionLog) {
      return;
    }

    const hasEmployerTaxBreakdown = this.payoutTransactionLog &&
      (this.payoutTransactionLog.TempYouthGrossSalary || 0) > 0;

    if (this.invoice && hasEmployerTaxBreakdown) {
      if ((this.payoutTransactionLog.TempYouthGrossSalary || 0) > 0) {
        this.tableRows.push({
          loneart: '1101 TempYouth',
          kmAntal: '',
          sekDag: '',
          arbGivAvg: this.payoutTransactionLog.TempYouthEmployerTaxAmount || 0,
          bruttoLon: this.payoutTransactionLog.TempYouthGrossSalary || 0,
          inkSkatt: '',
          nettoLonBelopp: ''
        });
      }

      if ((this.payoutTransactionLog.NormalGrossSalary || 0) > 0) {
        this.tableRows.push({
          loneart: '1101 Normal',
          kmAntal: '',
          sekDag: '',
          arbGivAvg: this.payoutTransactionLog.NormalEmployerTaxAmount || 0,
          bruttoLon: this.payoutTransactionLog.NormalGrossSalary || 0,
          inkSkatt: '',
          nettoLonBelopp: ''
        });
      }

      this.tableRows.push({
        loneart: '1101 Totalt',
        kmAntal: '',
        sekDag: '',
        arbGivAvg: arbGivAvg,
        bruttoLon: bruttoLon,
        inkSkatt: inkSkatt,
        nettoLonBelopp: nettoLonBelopp
      });
    }
    // Add main invoice payout row
    // Ensure this.invoice is not null/undefined before accessing its properties
    else if (this.invoice) {
      this.tableRows.push({
        loneart: '1101',
        kmAntal: '',
        sekDag: '',
        arbGivAvg: arbGivAvg,
        bruttoLon: bruttoLon,
        inkSkatt: inkSkatt, // Assumes PayoutMunicipalityTax is already set
        nettoLonBelopp: nettoLonBelopp
      });
    }

    // Add deductions rows
    if (Array.isArray(this.approvedDeductions)) {
      this.approvedDeductions.forEach((deduction: any) => {
        let loneart = '';
        if (deduction.TravelExpense) {
          loneart = '1223';
        } else if (deduction.HealthCare) {
          loneart = '1228';
        } else {
          loneart = '1224';
        }
        // Handle AddedToInvoice without optional chaining
        if (deduction && deduction.AddedToInvoice) {
          loneart += '1';
        }

        this.tableRows.push({
          loneart: loneart,
          kmAntal: '',
          sekDag: '',
          arbGivAvg: '',
          bruttoLon: '',
          inkSkatt: '',
          nettoLonBelopp: this.getDeductionAdjustedAmount(deduction)
        });
      });
    }

    // Add allowances rows
    // Handle Allowances array and its length without optional chaining
    if (this.invoice && this.invoice.Allowances && this.invoice.Allowances.length > 0) {
      this.invoice.Allowances.forEach((allowance: any) => { // Using 'any' as per previous request
        if (!allowance || allowance.ApprovedByAdmin !== true) { return; }
        if (allowance.Mileage > 0) {
          this.tableRows.push({
            loneart: '1232',
            kmAntal: allowance.Mileage,
            sekDag: '',
            arbGivAvg: '',
            bruttoLon: '',
            inkSkatt: '',
            nettoLonBelopp: allowance.Sum
          });
        }
        if (allowance.FullDays > 0) {
          this.tableRows.push({
            loneart: (allowance.AllowanceType && allowance.AllowanceType.Id === 2) ? '1201' : '1204',
            kmAntal: allowance.FullDays,
            sekDag: allowance.AllowancePerDay,
            arbGivAvg: '',
            bruttoLon: '',
            inkSkatt: '',
            nettoLonBelopp: allowance.sumAllowanceFullDays
          });
        }
        if (allowance.HalfDays > 0) {
          this.tableRows.push({
            loneart: (allowance.AllowanceType && allowance.AllowanceType.Id === 2) ? '1202' : '1204 (halv)',
            kmAntal: allowance.HalfDays,
            sekDag: allowance.AllowancePerDay / 2,
            arbGivAvg: '',
            bruttoLon: '',
            inkSkatt: '',
            nettoLonBelopp: allowance.sumAllowanceHalfDays
          });
        }
        if (allowance.Brekafasts > 0) {
          this.tableRows.push({
            loneart: (allowance.AllowanceType && allowance.AllowanceType.Id === 2) ? '1209' : '1215',
            kmAntal: allowance.Brekafasts,
            sekDag: '',
            arbGivAvg: '',
            bruttoLon: '',
            inkSkatt: '',
            nettoLonBelopp: allowance.BrekafastsAmount
          });
        }
        if ((allowance.Lunches > 0 || allowance.Dinners > 0) && (allowance.AllowanceType && allowance.AllowanceType.Id === 2)) {
          this.tableRows.push({
            loneart: '1210',
            kmAntal: allowance.Lunches + allowance.Dinners,
            sekDag: '',
            arbGivAvg: '',
            bruttoLon: '',
            inkSkatt: '',
            nettoLonBelopp: allowance.LunchesAmount + allowance.DinnersAmount
          });
        }
        if (allowance.Lunches > 0 && (allowance.AllowanceType && allowance.AllowanceType.Id === 3)) {
          this.tableRows.push({
            loneart: '1216',
            kmAntal: allowance.Lunches,
            sekDag: '',
            arbGivAvg: '',
            bruttoLon: '',
            inkSkatt: '',
            nettoLonBelopp: allowance.LunchesAmount
          });
        }
        if (allowance.Dinners > 0 && (allowance.AllowanceType && allowance.AllowanceType.Id === 3)) {
          this.tableRows.push({
            loneart: '1217',
            kmAntal: allowance.Dinners,
            sekDag: '',
            arbGivAvg: '',
            bruttoLon: '',
            inkSkatt: '',
            nettoLonBelopp: allowance.DinnersAmount
          });
        }
      });
    }

    // Historical pension must come from the selected payout log, not today's calculation.
    if (this.payoutTransactionLog.PensionSavings > 0) {
      this.tableRows.push({
        loneart: this.payoutTransactionLog.PensionSavingsCompany?.Name || '',
        kmAntal: '',
        sekDag: '',
        arbGivAvg: '',
        bruttoLon: '',
        inkSkatt: '',
        nettoLonBelopp: `${this.payoutTransactionLog.PensionSavings}+${this.payoutTransactionLog.PensionSavingsTaxAmount}`
      });
    }

    // Add Total PayOut row
    // Ensure this.invoice is not null/undefined before accessing PayOutTotal
    if (this.invoice) {
      this.tableRows.push({
        loneart: '1313',
        kmAntal: '',
        sekDag: '',
        arbGivAvg: '',
        bruttoLon: '',
        inkSkatt: '',
        nettoLonBelopp: payoutTotal
      });
    }


    // Add Wage Garnishment row
    // Ensure this.invoice is not null/undefined before accessing wageGarnishmentAmount
    if (this.invoice && this.userHasWageGarnishment) {
      this.tableRows.push({
        loneart: '1311',
        kmAntal: '',
        sekDag: '',
        arbGivAvg: '',
        bruttoLon: '',
        inkSkatt: '',
        nettoLonBelopp: garnishmentAmount
      });
    }

  }

  private getPreviousSwedishBankDay(date: Date): Date {
    const adjusted = new Date(date.getTime());
    if (isNaN(adjusted.getTime())) {
      return adjusted;
    }

    while (this.isSwedishBankHoliday(adjusted)) {
      adjusted.setDate(adjusted.getDate() - 1);
    } 
    return adjusted;
  }

  private getNextSwedishBankDay(date: Date): Date {
    const adjusted = new Date(date.getTime());
    if (isNaN(adjusted.getTime())) {
      return adjusted;
    }

    while (this.isSwedishBankHoliday(adjusted)) {
      adjusted.setDate(adjusted.getDate() + 1);
    }
    return adjusted;
  }

  private setDefaultPayoutDateForUnpaidInvoice(): void {
    if (!this.invoice || this.invoice.PayoutDate || !this.isInvoiceNotPaidOut()) {
      return;
    }

    const today = new Date();
    const dateOnlyToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const nextBankDay = this.getNextSwedishBankDay(dateOnlyToday);
    this.invoice.PayoutDate = nextBankDay;
  }

  private getSubtotalInputs(): number[] {
    return [
      this.invoice.PaidTotal, this.InvoiceFeeMember, this.InvoiceFeeReceiver,
      this.invoice.ExchangeFee, this.invoice.KronofogdenFee, this.invoice.ReminderFee,
      this.invoice.ServiceFee, this.invoice.InkassoFee, this.invoice.CustomFee,
      this.invoice.ManualDiscount, this.invoice.TotalVatAmount,
      this.invoice.Currency?.Name !== 'SEK' ? this.invoice.ExchangeRateInvoiceSent : 1
    ].map(value => Number(value) || 0);
  }

  get showPaidOutSubtotalWarning(): boolean {
    return this.isInvoiceAlreadyPaidOut() && this.originalSubtotalInputs !== null &&
      this.getSubtotalInputs().some((value, index) => value !== this.originalSubtotalInputs[index]);
  }

  isInvoiceAlreadyPaidOut(): boolean {
    const technicalName = this.invoice && this.invoice.PayoutStatus && this.invoice.PayoutStatus.TechnicalName;
    const statusName = (this.invoice && this.invoice.PayoutStatus && this.invoice.PayoutStatus.Name || '').toString().toLowerCase();
    return technicalName === 'PaidOut' || statusName === 'utbetald';
  }

  private isInvoiceNotPaidOut(): boolean {
    const technicalName = this.invoice && this.invoice.PayoutStatus && this.invoice.PayoutStatus.TechnicalName;
    const statusName = (this.invoice && this.invoice.PayoutStatus && this.invoice.PayoutStatus.Name || '').toString().toLowerCase();
    return technicalName === 'NotPaidOut' || statusName === 'ej utbetald';
  }

  private isSwedishBankHoliday(date: Date): boolean {
    if (!date || isNaN(date.getTime())) {
      return false;
    }

    const day = date.getDay();
    if (day === 0 || day === 6) {
      return true;
    }

    const holidays = this.getSwedishBankHolidaySet(date.getFullYear());
    return holidays.has(this.formatDateKey(date));
  }

  private getSwedishBankHolidaySet(year: number): Set<string> {
    if (this.swedishBankHolidayCache.has(year)) {
      return this.swedishBankHolidayCache.get(year);
    }

    const holidays = new Set<string>();
    const addDate = (d: Date) => holidays.add(this.formatDateKey(d));

    addDate(new Date(year, 0, 1));  // Nyårsdagen
    addDate(new Date(year, 0, 6));  // Trettondedag jul
    addDate(new Date(year, 4, 1));  // Första maj
    addDate(new Date(year, 5, 6));  // Nationaldagen
    addDate(new Date(year, 11, 24)); // Julafton
    addDate(new Date(year, 11, 25)); // Juldagen
    addDate(new Date(year, 11, 26)); // Annandag jul
    addDate(new Date(year, 11, 31)); // Nyårsafton

    const easterSunday = this.getEasterSunday(year);
    const goodFriday = new Date(easterSunday.getTime());
    goodFriday.setDate(goodFriday.getDate() - 2);
    const easterMonday = new Date(easterSunday.getTime());
    easterMonday.setDate(easterMonday.getDate() + 1);
    const ascensionDay = new Date(easterSunday.getTime());
    ascensionDay.setDate(ascensionDay.getDate() + 39);

    addDate(goodFriday);
    addDate(easterMonday);
    addDate(ascensionDay);

    const midsummerEve = this.getWeekdayOnOrAfter(new Date(year, 5, 19), 5);
    const allSaintsDay = this.getWeekdayOnOrAfter(new Date(year, 9, 31), 6);
    addDate(midsummerEve);
    addDate(allSaintsDay);

    this.swedishBankHolidayCache.set(year, holidays);
    return holidays;
  }

  private getWeekdayOnOrAfter(startDate: Date, targetWeekday: number): Date {
    const date = new Date(startDate.getTime());
    while (date.getDay() !== targetWeekday) {
      date.setDate(date.getDate() + 1);
    }
    return date;
  }

  private getEasterSunday(year: number): Date {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  }

  private formatDateKey(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  config = {
    disableClose: false,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '500px',
    height: '',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
      invoiceItemGroup: {},
      customerTemplate: {},
      customer: {},
      contact: {},
      companyId: 0
    },
    dataTemplate: {
      "Id": 0,
      "Type": {},
      "HoursWorked": undefined,
      "StartDate": undefined,
      "EndDate": undefined,
      "Comment": undefined,
      "InvoiceId": 0
    }
  }
}




